import DefaultLayout from 'layouts/DefaultLayout';
import { Processing } from 'shared/pages/processing/Processing';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import React from 'react';

export const LoginRedirect = () => {
  UserPasswordlessManager.instance()
    .clearStaleState()
    .then(() => {
      UserPasswordlessManager.instance().signinRedirect();
    });
  return (
    <DefaultLayout>
      <Processing message={'Redirecting...'} />
    </DefaultLayout>
  );
};
